import _Paper from "@material-ui/core/esm/Paper";
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { variables } from 'swag-client-common/styles/variables-js';
const StyledPaper = withStyles({
  root: {
    padding: '20px 15px',
    color: 'rgb(255, 57, 53)',
    marginBottom: '20px',
    boxShadow: '0px 2px 24px 6px rgba(108, 109, 110, 0.07)',
    borderRadius: 0,
    fontSize: '18px',
    lineHeight: '36px',
    font: variables.fontFamilyRegular
  }
})(_Paper);
export default class GiveawayFormError extends React.PureComponent {
  render() {
    const {
      error
    } = this.props;
    return /*#__PURE__*/React.createElement(StyledPaper, null, error);
  }
}